import { agent, settings } from "~/core/paths";
import { type ReadingSlug, readingPath } from "~/modules/analytics/lib/loop";

const DESTINATIONS: Record<string, ReadingSlug> = {
	no_questions: "prompts",
	factcheck_high: "factcheck",
	gaps_open: "gaps",
	pages_review: "drafts",
	publishing_review: "distribution",
	publishing_attention: "distribution",
	badge_missing: "badge",
};

/** The reading a to-do belongs to, where it belongs to one. */
function actionReading(code: string): ReadingSlug | null {
	return DESTINATIONS[code] ?? null;
}

/** And where its button goes. */
export function actionPath(entityId: string, code: string): string {
	const base = `/w/${entityId}`;
	// The usual cause of "nobody cited you" is a name we never learned, not an
	// absence — so those two go to the aliases, not to a chart of zeroes.
	if (code === "not_cited" || code === "few_datapoints") return `${base}/settings`;
	if (code.startsWith("publishing_")) return `${readingPath(base, "distribution")}?tab=history`;
	if (code === "low_credits") return settings(entityId, "subscription");
	// The one card that is not about a decision: the run is already going, and
	// the only thing to look at is the run.
	if (code === "sampling_now" || code === "setup_running" || code === "setup_preparing")
		return `${base}/tasks?status=active`;
	if (code === "tasks_failed") return `${base}/tasks?status=failed`;
	// The workflow is the thing that stopped, and the canvas is where its failed
	// step and its Run button are.
	if (code.startsWith("setup_") || code.startsWith("loop_")) return agent(entityId, "home");
	const reading = actionReading(code);
	return reading ? readingPath(base, reading) : base;
}
